import { api } from "@/shared/api/instance";
import type { DictionariesResponse, FlightMarkupListResponse } from "../types";

interface FlightsDictionary {
  airlines: { code: string; label: string }[];
  statuses: { code: string; label: string }[];
  flightTypes: { code: string; label: string }[];
}

export const getFlightMarkups = async (
  query: any
): Promise<FlightMarkupListResponse> => {
  const response = await api.get<any>("/api/v1/flights", {
    params: query,
  });
  return response.data;
};
export const getMarkupsOptions = async (): Promise<FlightsDictionary> => {
  const response = await api.get<any>("/api/v1/flights/options");
  return response.data;
};

export type MarkupType = "percent" | "absolute";

export interface SetFlightMarkupBody {
  type: MarkupType;
  value: number;
  apply?: string;
}

export const setFlightMarkup = (flightId: number, body: SetFlightMarkupBody) =>
  api.put(`/api/v1/flights/${flightId}/markup`, body);

export const cancelFlight = (flightId: number) => {
  const response = api.put(`/api/v1/flights/${flightId}/cancel`);
  return response;
};

export const publishFlight = (flightId: number) => {
  const response = api.put(`/api/v1/flights/${flightId}/publish`);
  return response;
};
